function Update1() {

    return (<div>
        Content
    </div>);
}

export default Update1;